import { ISolicitudDocumentoModel } from "../../interfaces/solicitud/documento/ISolicitudDocumentModel";
import { ISolicitudEquipoValidarModel } from "../../interfaces/solicitud/equipos/ISolicitudEquipoValidarModel";
import { SolicitudDocumentoModel } from "../documento/SolicitudDocumentoModel";

export class SolicitudEquipoValidarModel implements ISolicitudEquipoValidarModel {
    idSolicitudEquipo: number;    
    documentos: ISolicitudDocumentoModel[];
    comentarios: string;
    idEstado: number;

    constructor(){
        this.idSolicitudEquipo = 0;
        this.documentos = new Array<SolicitudDocumentoModel>();
        this.comentarios = '';
        this.idEstado = 0;
    }
}